import { render, staticRenderFns } from "./apiProductDetail.vue?vue&type=template&id=7ec0dcba&scoped=true&"
import script from "./apiProductDetail.vue?vue&type=script&lang=js&"
export * from "./apiProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./apiProductDetail.vue?vue&type=style&index=0&id=7ec0dcba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec0dcba",
  null
  
)

export default component.exports